// ОТЛАДОЧНЫЙ ЭКСПОРТ ОТВЕТОВ — `?debug` → «copy my answers» (тикет `3f319875cbb88182bd7fdd9380e51b5d`).
//
// Зачем: ответы живут только в `localStorage` телефона (`lifemap.wizard`), достать их оттуда нечем.
// Кнопка кладёт в буфер JSON конверта ровно в том виде, в каком его пишет `writeSession`, — CC
// подкладывает его тем же путём, что e2e (`seedOnce`), и воспроизводит экраны один в один.
//
// ⛔ Только под `?debug`. Без параметра узла нет вовсе. Данные никуда не уходят: только буфер
// обмена самого человека. Надписи — служебные, не продуктовая копи.
//
// ⚠️ ЗАПАСНОЙ ПУТЬ — ПОЛЕ С ТЕКСТОМ. `navigator.clipboard` есть не везде (не-HTTPS, старый WebKit,
// запрет разрешения) — тогда JSON печатается в поле только для чтения, выделенным: «скопировать»
// руками. Молча ничего не сделать — хуже: человек решит, что скопировал.

import { useRef, useState } from 'react';

/** Есть ли `debug` в строке запроса (значение не важно: `?debug`, `?debug=1`). */
export function isDebugSearch(search) {
  return new URLSearchParams(search || '').has('debug');
}

/** JSON конверта для буфера — тот же объект, что пишет `writeSession`. */
export function exportJson(session) {
  return JSON.stringify(session);
}

export default function DebugExport({ session }) {
  const [state, setState] = useState('idle');
  const [text, setText] = useState('');
  const fieldRef = useRef(null);

  const copy = () => {
    const json = exportJson(session);
    setText(json);
    const fallback = () => {
      setState('manual');
      // Выделить после отрисовки поля — пальцу останется «Copy».
      setTimeout(() => fieldRef.current?.select(), 0);
    };
    if (!navigator.clipboard?.writeText) {
      fallback();
      return;
    }
    navigator.clipboard.writeText(json).then(() => setState('copied'), fallback);
  };

  return (
    <div
      data-testid="debug-export"
      className="fixed right-2 top-2 z-50 flex max-w-[80vw] flex-col items-end gap-1 font-mono text-[11px]"
    >
      <button
        type="button"
        data-testid="debug-copy"
        data-state={state}
        onClick={copy}
        className="border border-[var(--paper-mute)] bg-[var(--ink-900)] px-2 py-1 text-[var(--paper)]"
      >
        {state === 'copied' ? 'copied' : 'copy my answers'}
      </button>
      {state === 'manual' ? (
        <textarea
          ref={fieldRef}
          data-testid="debug-json"
          readOnly
          value={text}
          rows={4}
          className="w-[70vw] border border-[var(--paper-mute)] bg-[var(--ink-900)] p-1 text-[16px] text-[var(--paper)]"
        />
      ) : null}
    </div>
  );
}
